module.exports = __webpack_public_path__ + "static/media/onikiri2.0fffe53b.jpg";